import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=61ed099e&scoped=true"
import script from "./GlobalLoading.vue?vue&type=script&lang=js"
export * from "./GlobalLoading.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=61ed099e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed099e",
  null
  
)

export default component.exports